const postPlacesStr = {
  toastr: 'place added',
  toastr1: 'has been successfully added',
  toastrError: 'Place already registered',
  toastrError1: 'Enter another name'
};

export default postPlacesStr;
